import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { GenericSimpleButton, GenericSimpleIconButton, GenericAlert } from 'com-gyf-webcore-userinterfacecomponents';
import ProcessManager from '../../../Common/Managers/ProcessManager';

const GenericAlertWrapper = ({ showError }) => {
    if (!showError)
        return null;

    return <GenericAlert message="Por favor seleccione una empresa" type="danger" />;
}

class Footer extends Component {
    constructor(props) {
        super(props);
        this.routeToNuevaSolicitudCuenta = this.routeToNuevaSolicitudCuenta.bind(this)
    }

    cancelClick() {
        $("#discardChangesModal").modal();
    }

    routeToNuevaSolicitudCuenta() {
        let empresaSeleccionada = false;
        let empId=null;

        for (var i = 0; i < this.props.data.empresas.length; i++) {
            if (this.props.data.empresas[i].seleccionada) {
                empresaSeleccionada = true;
                empId = this.props.data.empresas[i].Id;
                break;
            }
        }

        if (empresaSeleccionada) {
            if(this.props.data.empresas.some(empresa=>empresa.Id == 0)){
                this.props.seleccionarEmpresa(0);
            }else{
                if(this.props.tarjetas.esModificacion && empId){
                    this.props.seleccionarEmpresa(empId);
                }
            } 
            this.props.routeToNuevaSolicitudCuenta();
        }
        else {
            this.props.showError();
        }
    }

    render() {
        if (this.props.data.redirectToNuevaSolicitudCuenta)
            return <Redirect to={ProcessManager.GetNextStep("NuevaSolicitudEmpresa", "ROUTE_TO_CUENTA")} push />

        let btn;
        let permisos = this.props.permisos;
        let disabledGuardarBorradorProp = { disabled: "disabled" };

        if (permisos.components.BotonNuevaEmpresa.Locked == false) {
            delete disabledGuardarBorradorProp.disabled;
        }
        if (this.props.data.esSolicitudGuardada) {
            btn = <GenericSimpleIconButton text="Guardar Borrador" buttonClass="btn btn-secondary disabled" />
        }
        else {
            btn = <button className="btn btn-secondary" type="submit"
                onClick={() => this.props.guardarSolicitudBorrador()}
                {...disabledGuardarBorradorProp}>Guardar Borrador</button>
        }
        return (
            <div className="row">
                {(permisos.components.BotonesAnteriorSiguiente.Active == true) &&
                    <div className="col-md-2">
                        <Link to={!this.props.tarjetas.esModificacion ? ProcessManager.GetNextStep("NuevaSolicitudEmpresa", "ROUTE_TO_TIPO_EMPRESA"):ProcessManager.GetNextStep("NuevaSolicitudEmpresa", "ROUTE_TO_VISTA_CLIENTE")} className="btn btn-secondary">&#60; Anterior</Link>
                    </div>}
                <div className="col-md-2">
                    <Link to={ProcessManager.GetNextStep("NuevaSolicitudEmpresa", "ROUTE_TO_VISTA_CLIENTE")} className="btn btn-secondary">Cancelar</Link>
                </div>
                <div className="col-md-3">
                </div>
                {/*(permisos.components.BotonGuardarBorrador.Active == true) &&
                    <div className="col-md-3">
                        {btn}
                </div>*/}
                {(permisos.components.BotonesAnteriorSiguiente.Active == true) &&
                    <div className="col-md-5">
                        <GenericSimpleButton text="Siguiente > " buttonClass="btn btn-cta float-right" onClick={this.routeToNuevaSolicitudCuenta} />
                    </div>}
            </div>
        );
    }
};

export default Footer